// Dynamic theming based on association's primary color (stored in DB as hex)

function hexToRgb(hex) {
  const h = hex.replace('#', '');
  const bigint = parseInt(h.length === 3 ? h.split('').map((c) => c + c).join('') : h, 16);
  return { r: (bigint >> 16) & 255, g: (bigint >> 8) & 255, b: bigint & 255 };
}

// Compute YIQ luminance to determine if text should be light or dark
function getContrastColor(hex) {
  const { r, g, b } = hexToRgb(hex);
  const yiq = (r * 299 + g * 587 + b * 114) / 1000;
  return yiq >= 140 ? '#0F172A' : '#FFFFFF';
}

export function applyTheme(hex) {
  if (!hex) return;
  try {
    const { r, g, b } = hexToRgb(hex);
    const root = document.documentElement;
    root.style.setProperty('--theme-primary', hex);
    root.style.setProperty('--theme-primary-foreground', getContrastColor(hex));
    root.style.setProperty('--theme-primary-soft', `rgba(${r}, ${g}, ${b}, 0.1)`);
    root.style.setProperty('--theme-primary-strong', `rgba(${r}, ${g}, ${b}, 0.22)`);
    root.style.setProperty('--theme-primary-rgb', `${r}, ${g}, ${b}`);
  } catch {}
}

export function resetTheme() {
  const root = document.documentElement;
  root.style.setProperty('--theme-primary', '#0F172A');
  root.style.setProperty('--theme-primary-foreground', '#FFFFFF');
  root.style.setProperty('--theme-primary-soft', 'rgba(15, 23, 42, 0.08)');
  root.style.setProperty('--theme-primary-strong', 'rgba(15, 23, 42, 0.18)');
  root.style.setProperty('--theme-primary-rgb', '15, 23, 42');
}
